import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookSquare,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import logofull from "assets/logo.webp";
import { MEET_PAGE_ENABLED } from "config/featureFlags";
import "./footer.css";
import "styles/siteChrome.css";

const REGISTER_URL = `https://app.jackrabbitclass.com/regv2.asp?id=${process.env.REACT_APP_ORGID}`;
const PORTAL_URL =
  "https://app.jackrabbitclass.com/jr3.0/ParentPortal/Login?orgID=539177";

const Footer = () => {
  const programTitles = useSelector(
    (state) => state.contentfulReducer.programTitles
  );
  const calendar = useSelector((state) => state.contentfulReducer.calendar);
  const calendarLabel = calendar?.label || "Calendar";

  const scrollToTop = () => window.scrollTo(0, 0);

  return (
    <footer className="site-footer">
      <div className="site-footer__main">
        <div className="site-footer__inner">
          <div className="site-footer__brand">
            <Link to="/" className="site-footer__logo" onClick={scrollToTop}>
              <img
                src={logofull}
                alt="Ace Gymnastics"
                width="100"
                height="100"
              />
            </Link>
            <p className="site-footer__tagline">
              Where kids are <strong>Active</strong>, <strong>Confident</strong>
              , and <strong>Empowered</strong>.
            </p>
            <p className="site-footer__location">
              Family-owned gymnastics in Bardstown, Kentucky
            </p>
          </div>

          <nav className="site-footer__col" aria-label="Quick links">
            <h2 className="site-footer__heading">Explore</h2>
            <ul>
              <li>
                <Link to="/" onClick={scrollToTop}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/staff" onClick={scrollToTop}>
                  Staff
                </Link>
              </li>
              <li>
                <Link to="/events" onClick={scrollToTop}>
                  Events
                </Link>
              </li>
              {MEET_PAGE_ENABLED && (
                <li>
                  <Link to="/bourbon-city-spectacular" onClick={scrollToTop}>
                    Bourbon City Spectacular
                  </Link>
                </li>
              )}
              <li>
                <Link to="/programs/program-details/" onClick={scrollToTop}>
                  Programs
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={scrollToTop}>
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/employment" onClick={scrollToTop}>
                  Employment
                </Link>
              </li>
              <li>
                <Link to="/calendar" onClick={scrollToTop}>
                  {calendarLabel}
                </Link>
              </li>
            </ul>
          </nav>

          <nav className="site-footer__col" aria-label="Programs">
            <h2 className="site-footer__heading">Programs</h2>
            <ul>
              {programTitles.map((program) => (
                <li key={program.fields.displayName}>
                  <Link
                    to={`/programs/program-details/${program.fields.displayName}`}
                    onClick={scrollToTop}
                  >
                    {program.fields.displayName}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="site-footer__col site-footer__contact">
            <h2 className="site-footer__heading">Contact</h2>
            <address>
              <p>
                <a href="tel:502-252-8512" data-track="phone_click" data-track-location="footer">502-252-8512</a>
              </p>
              <p>
                <a
                  href="mailto:office@ace-gymnastics.com"
                  data-track="email_click"
                  data-track-location="footer"
                >
                  office@ace-gymnastics.com
                </a>
              </p>
              <p>2388 New Haven Road</p>
              <p>Bardstown, KY 40004</p>
            </address>
            <div className="site-footer__social">
              <a
                href="https://www.facebook.com/ACE-Gymnastics-101806134601903/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                data-track="social_click"
                data-track-location="footer"
                data-track-label="facebook"
              >
                <FontAwesomeIcon icon={faFacebookSquare} />
              </a>
              <a
                href="https://www.instagram.com/ace.gymnastics/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-track="social_click"
                data-track-location="footer"
                data-track-label="instagram"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
            <div className="site-footer__ctas">
              <a
                href={REGISTER_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="site-btn site-btn--accent"
                data-track="register_click"
                data-track-location="footer"
              >
                Register
              </a>
              <a
                href={PORTAL_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="site-btn site-btn--outline-light"
                data-track="parent_portal_click"
                data-track-location="footer"
              >
                Parent Portal
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="site-footer__inner site-footer__bottom-inner">
          <p className="site-footer__copy">
            © {new Date().getFullYear()} Ace Gymnastics. All rights reserved.
          </p>
          <p className="site-footer__legal">
            <Link to="/privacy" onClick={scrollToTop}>
              Privacy Policy
            </Link>
          </p>
          <p className="site-footer__credit">
            Website by{" "}
            <a
              href="https://www.bourboncitywebdevelopment.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Bourbon City Web Development
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
